import React, {Fragment, useEffect, useState} from 'react';
import './AdminBoxes.css';
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import AdminHeader from "../AdminHeader/AdminHeader";

const AdminBoxes = () => {

    const navigate = useNavigate();
    const [choosedBox, setChoosedBox] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const [boxesId, setBoxesId] = useState({'1': [null, false], '2': [null, false], '3': [null, false], '4': [null, false], '5': [null, false], '6': [null, false],
        '7': [null, false], '8': [null, false], '9': [null, false], '10': [null, false], '11': [null, false], '12': [null, false]});


    useEffect(() => {
        axios.get(`/api/shelves/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.data.detail.length !== 0) {
                    for (let box of res.data.detail) {
                        if (box.status === 'occupied') {
                            document.getElementById('u-box-' + box.name)?.classList.add('u-box-reserved-admin');
                        }
                        setBoxesId(prevState => ({ ...prevState, [box.name]: [box.id, box.is_blocked] }))
                    }
                }
                setLoaded(true);
            })
            .catch(e => {
                console.log(e);
                setLoaded(true);
            })
    }, [setBoxesId, setLoaded]);


    const selectBox = (num) => {
        setChoosedBox(num);
    }

    const goBack = () => {
        navigate(-1);
    }

    const openUserBox = () => {
        console.log(boxesId[choosedBox], ' ', choosedBox);
        axios.get(`/api/admin_open/?shelf_id=${boxesId[choosedBox][0]}`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.status === 200) {
                    console.log('Дверь успешно открыта');
                    // navigate('/box_reserve/user_reserved');
                    alert('Ящик открыт');
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
            })
    }

    const blockUserBox = () => {
        console.log(boxesId[choosedBox], ' ', choosedBox);
        axios.get(`/api/admin_block/?shelf_id=${boxesId[choosedBox][0]}`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.status === 200) {
                    console.log('Дверь заблокирована');
                    setBoxesId(prevState => ({ ...prevState, [choosedBox]: [boxesId[choosedBox][0], !boxesId[choosedBox][1]] }))
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
            })
    }


    return (
        <div className={'user-equipment-container'}>
            <AdminHeader />
            {/*<div className={`user-equipment-title admin-boxes-title ${loaded ? '' : 'u-eq-page-not-loaded'}`}>Мой шкаф:</div>*/}

            <div className={`user-equipment-box-container admin-boxes-container ${loaded ? '' : 'u-eq-page-not-loaded'}`}>
                <div className={'user-equipment-box-row'}>
                    <div id={'u-box-1'} className={`user-equipment-box ${choosedBox === '1' ? 'user-equipment-box-selected' : ''} ${boxesId['1'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('1')}>
                        <p className={'user-equipment-box-number'}>1</p>
                    </div>
                    <div id={'u-box-2'} className={`user-equipment-box ${choosedBox === '2' ? 'user-equipment-box-selected' : ''} ${boxesId['2'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('2')}>
                        <p className={'user-equipment-box-number'}>2</p>
                    </div>
                    <div id={'u-box-3'} className={`user-equipment-box ${choosedBox === '3' ? 'user-equipment-box-selected' : ''} ${boxesId['3'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('3')}>
                        <p className={'user-equipment-box-number'}>3</p>
                    </div>
                </div>

                <div className={'user-equipment-box-row'}>
                    <div id={'u-box-4'} className={`user-equipment-box ${choosedBox === '4' ? 'user-equipment-box-selected' : ''} ${boxesId['4'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('4')}>
                        <p className={'user-equipment-box-number'}>4</p>
                    </div>
                    <div id={'u-box-5'} className={`user-equipment-box ${choosedBox === '5' ? 'user-equipment-box-selected' : ''} ${boxesId['5'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('5')}>
                        <p className={'user-equipment-box-number'}>5</p>
                    </div>
                    <div id={'u-box-6'} className={`user-equipment-box ${choosedBox === '6' ? 'user-equipment-box-selected' : ''} ${boxesId['6'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('6')}>
                        <p className={'user-equipment-box-number'}>6</p>
                    </div>
                </div>

                <div className={'user-equipment-box-row'}>
                    <div id={'u-box-7'} className={`user-equipment-box ${choosedBox === '7' ? 'user-equipment-box-selected' : ''} ${boxesId['7'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('7')}>
                        <p className={'user-equipment-box-number'}>7</p>
                    </div>
                    <div id={'u-box-8'} className={`user-equipment-box ${choosedBox === '8' ? 'user-equipment-box-selected' : ''} ${boxesId['8'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('8')}>
                        <p className={'user-equipment-box-number'}>8</p>
                    </div>
                    <div id={'u-box-9'} className={`user-equipment-box ${choosedBox === '9' ? 'user-equipment-box-selected' : ''} ${boxesId['9'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('9')}>
                        <p className={'user-equipment-box-number'}>9</p>
                    </div>
                </div>

                {/*<div className={'user-equipment-box-row'}>*/}
                {/*    <div id={'u-box-10'} className={`user-equipment-box ${choosedBox === '10' ? 'user-equipment-box-selected' : ''} ${boxesId['10'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('10')}>*/}
                {/*        <p className={'user-equipment-box-number'}>10</p>*/}
                {/*    </div>*/}
                {/*    <div id={'u-box-11'} className={`user-equipment-box ${choosedBox === '11' ? 'user-equipment-box-selected' : ''} ${boxesId['11'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('11')}>*/}
                {/*        <p className={'user-equipment-box-number'}>11</p>*/}
                {/*    </div>*/}
                {/*    <div id={'u-box-12'} className={`user-equipment-box ${choosedBox === '12' ? 'user-equipment-box-selected' : ''} ${boxesId['12'][1] ? 'u-box-blocked' : ''}`} onClick={() => selectBox('12')}>*/}
                {/*        <p className={'user-equipment-box-number'}>12</p>*/}
                {/*    </div>*/}
                {/*</div>*/}

            </div>

            <div className={`user-equipment-button-container ${loaded ? '' : 'u-eq-page-not-loaded'}`}>
                {/*<div className={'admin-boxes-buttons-in-line'}>*/}
                {/*    <div className={'user-equipment-button u-eq-btn-opn admin-boxes-button-in-row'}*/}
                {/*         onClick={() => openUserBox()}>Открыть*/}
                {/*    </div>*/}
                {/*    <div className={'user-equipment-button u-eq-admin-btn-close admin-boxes-button-in-row'}*/}
                {/*         onClick={() => openUserBox()}>Закрыть*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className={'user-equipment-button u-eq-btn-opn admin-boxes-button-not-in-row'}
                     onClick={() => openUserBox()}>Открыть
                </div>
                <div
                    className={`user-equipment-button admin-boxes-button-not-in-row ${choosedBox ? '' : 'u-eq-btn-not-able'} ${boxesId[choosedBox]?.[1] ? 'u-eq-btn-opn' : 'u-eq-admin-btn-block'}`}
                    onClick={() => blockUserBox()}>{boxesId[choosedBox]?.[1] ? 'Разблокировать' : 'Заблокировать'}
                </div>
                <div className={'user-equipment-button u-eq-btn-back admin-boxes-button-not-in-row'}
                     onClick={() => goBack()}>Назад
                </div>
            </div>
        </div>
    );
};

export default AdminBoxes;